import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdCheckCircle } from 'react-icons/md';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  password: '',
  confirmPassword: '',
  role: 'parent',
};

export default function RegisterQuickForm({ onSubmit, isSubmitting, onSwitchToLogin }) {
  const [form, setForm] = useState(initialState);
  const [error, setError] = useState('');

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.firstName.trim() || !form.lastName.trim()) {
      setError('Unesite ime i prezime.');
      return;
    }
    if (!form.email.trim()) {
      setError('Email je obavezan.');
      return;
    }
    if (form.password.trim().length < 6) {
      setError('Lozinka mora imati najmanje 6 karaktera.');
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError('Lozinke se ne poklapaju.');
      return;
    }

    await onSubmit({
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      email: form.email.trim(),
      phone: form.phone.trim(),
      password: form.password.trim(),
      role: form.role,
      preferences: {
        isLookingForBabysitter: form.role === 'parent',
      },
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input
          type="text"
          value={form.firstName}
          onChange={(e) => updateField('firstName', e.target.value)}
          placeholder="Ime"
          className="input-base"
          autoComplete="given-name"
          required
        />
        <input
          type="text"
          value={form.lastName}
          onChange={(e) => updateField('lastName', e.target.value)}
          placeholder="Prezime"
          className="input-base"
          autoComplete="family-name"
          required
        />
      </div>

      <input
        type="email"
        value={form.email}
        onChange={(e) => updateField('email', e.target.value)}
        placeholder="Email adresa"
        className="input-base"
        autoComplete="email"
        required
      />

      <input
        type="tel"
        value={form.phone}
        onChange={(e) => updateField('phone', e.target.value)}
        placeholder="Telefon (opciono)"
        className="input-base"
        autoComplete="tel"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input
          type="password"
          value={form.password}
          onChange={(e) => updateField('password', e.target.value)}
          placeholder="Lozinka"
          className="input-base"
          autoComplete="new-password"
          minLength={6}
          required
        />
        <input
          type="password"
          value={form.confirmPassword}
          onChange={(e) => updateField('confirmPassword', e.target.value)}
          placeholder="Potvrdi lozinku"
          className="input-base"
          autoComplete="new-password"
          minLength={6}
          required
        />
      </div>

      <div>
        <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tip naloga</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button
            type="button"
            onClick={() => updateField('role', 'parent')}
            className={`p-3 rounded-2xl border-2 text-left transition-all ${
              form.role === 'parent'
                ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20'
                : 'border-gray-200 dark:border-gray-700 hover:border-primary-300'
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="font-medium text-gray-900 dark:text-gray-100">Tražim dadilju</span>
              {form.role === 'parent' && <MdCheckCircle className="text-primary-600 text-xl" />}
            </div>
          </button>
          <button
            type="button"
            onClick={() => updateField('role', 'babysitter')}
            className={`p-3 rounded-2xl border-2 text-left transition-all ${
              form.role === 'babysitter'
                ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20'
                : 'border-gray-200 dark:border-gray-700 hover:border-primary-300'
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="font-medium text-gray-900 dark:text-gray-100">Tražim posao</span>
              {form.role === 'babysitter' && <MdCheckCircle className="text-primary-600 text-xl" />}
            </div>
          </button>
        </div>
      </div>

      {error && (
        <div className="p-3 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-sm text-red-700 dark:text-red-300">
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={isSubmitting}
        className="btn-primary w-full disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {isSubmitting ? 'Kreiranje naloga...' : 'Registruj se'}
      </button>

      <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
        Registracijom prihvatate <Link to="/terms" className="text-primary-600">Uslove korišćenja</Link> i <Link to="/privacy" className="text-primary-600">Izjavu o privatnosti</Link>.
      </p>

      {onSwitchToLogin && (
        <p className="text-sm text-center text-gray-600 dark:text-gray-400">
          Već imate nalog?{' '}
          <button type="button" onClick={onSwitchToLogin} className="text-primary-600 dark:text-primary-400 font-semibold">
            Uloguj se
          </button>
        </p>
      )}
    </form>
  );
}
